/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MapsViewModel { 
    id?: string;
    description?: string;
    name?: string;
    version?: number;
    mimeType?: string;
    location?: string;
    zoomLevel?: number;
    default?: boolean;
    file?: string;
}